
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Informações Pessoais',
    },
    {
        id: 2,
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'nome',
        maxlength: 200,
        label: 'Nome',
        rules: ['required']
    },
    {
        id: 1,
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'text',
        field: 'cpf',
        label: 'CPF',
        mask: 'cpf',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'text',
        field: 'rg',
        label: 'RG',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'date',
        field: 'dt_nas',
        label: 'Data de Nascimento',
        mask:'date',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'select-tipo',
        tipo: 59,
        valor: 'valor',
        field: 'sexo',
        label: 'Sexo',
        rules: ['required']
    },
    {
        id: 3,
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'email',
        field: 'email',
        maxlength: 100,
        label: 'Email',
        rules: ['email']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
        type: 'text',
        maxlength: 100,
        field: 'tel_res',
        label: 'Telefone',
        mask: 'telefone',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
        type: 'text',
        maxlength: 100,
        field: 'tel_cel',
        label: 'Celular',
        mask: 'celular',
        rules: ['']
    },
    // {
    //     class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
    //     type: 'boolean',
    //     field: 'pcd',
    //     info:'Marque essa opção se o funcionário possui algum necessidade especial.',
    //     label: 'PCD',
    //     rules: ['']
    // },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Informações Trabalhistas',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'select-custom',
        field: 'id_fdt',
        option: {
            key: 'id',
            label: 'fdt',
            value: 'id'
        },
        label: 'Frente de Trabalho',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'select-custom',
        field: 'id_funcao',
        label: 'Função',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'select-ghe',
        field: 'id_ghe',
        label: 'GHE (Setor)',
        info:'Somente se tiver PCMSO cadastrado',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
        type: 'text',
        maxlength: 100,
        field: 'pis',
        label: 'PIS',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
        type: 'text',
        maxlength: 100,
        field: 'mat',
        label: 'Matrícula',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        maxlength: 100,
        field: 'ct_num',
        label: 'Carteira de Trabalho (Número):',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        maxlength: 100,
        field: 'ct_serie',
        label: 'Carteira de Trabalho (Série):',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        maxlength: 100,
        field: 'ct_uf',
        label: 'Carteira de Trabalho (UF):',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Endereço Residencial',
    },
    {
        id: 5,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'cep',
        maxlength: 10,
        field: 'cep',
        label: 'CEP',
        mask: 'cep',
        rules: ['']
    },
    {
        id: 6,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
        type: 'text',
        maxlength: 500,
        field: 'end',
        label: 'Endereço',
        rules: ['']
    },
    {
        id: 6,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'text',
        maxlength: 50,
        field: 'num',
        label: 'Número',
        rules: ['']
    },
    {
        id: 7,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
        type: 'text',
        maxlength: 100,
        field: 'bairro',
        label: 'Bairro',
        rules: ['']
    },
    {
        id: 7,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        maxlength: 50,
        field: 'comp',
        label: 'Complemento',
        rules: ['']
    },
    {
        id: 8,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'select-uf',
        field: 'id_estado',
        label: 'Estado',
        rules: ['']
    },
    {
        id: 9,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'select-cidade',
        field: 'id_cidade',
        label: 'Cidade',
        rules: ['']
    },
    {
        id: 14,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Observações',
        maxlength: 500,
        rules: ['']
    }
];



// WEBPACK FOOTER //
// ./src/components/apps/empresa/funcionario/_form/funcionario-editar.js